import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styles/styled-components';
import messages from './messages';
import SVGIcon from 'components/SVGIcon/SVGIcon';
import ArrowRight from './arrowRight.svg';
import { RouteComponentProps, RouteProps, withRouter } from 'react-router-dom';
import ReferrerStep1 from './images/referrerStep1.png';
import ReferrerStep2 from './images/referrerStep2.png';
import ReferrerStep3 from './images/referrerStep3.png';
import ReferrerStep1En from './images/referrerStep1En.png';
import ReferrerStep2En from './images/referrerStep2En.png';
import ReferrerStep3En from './images/referrerStep3En.png';
import RefereeStep1 from './images/refereeStep1.png';
import RefereeStep2 from './images/refereeStep2.png';
import RefereeStep3 from './images/refereeStep3.png';
import RefereeStep1En from './images/refereeStep1En.png';
import RefereeStep2En from './images/refereeStep2En.png';
import RefereeStep3En from './images/refereeStep3En.png';
import Benefit1 from './images/benefit1.png';
import Benefit2 from './images/benefit2.png';
import Benefit3 from './images/benefit3.png';
import translations from 'translations';

// --------------- Styled Components ---------------

const maxWidth = 1272;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 106px -40px 0px;
  @media (max-width: 991px) {
    margin: 100px 0px 0px;
  }
`;

// --- Hero Section ---
const HeroSection = styled.section`
  position: relative;
  background: linear-gradient(105deg, #15803d 0%, #16a34a 40%, #009966 100%);
  padding: 80px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 520px;
  overflow: hidden;
  @media (max-width: 991px) {
    padding: 40px 0;
    min-height: unset;
  }
`;

const HeroInner = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  width: 100%;
  max-width: ${maxWidth}px;
  position: relative;
  z-index: 1;
  padding: 0px 16px;
  @media (max-width: 991px) {
    flex-direction: column;
    gap: 24px;
  }
`;

const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 602px;
  flex-shrink: 0;
  flex-basis: 52%;
  @media (max-width: 991px) {
    width: 100%;
    gap: 24px;
  }
`;

const HeroImagePlaceholder = styled.div`
  flex: 1;
  padding-top: 29%;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 26px;
  flex-basis: 48%;
  @media (max-width: 991px) {
    width: 100%;
    padding-top: 40%;
  }
  @media (max-width: 767px) {
    padding-top: 62%;
  }
`;

const HeroTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media (max-width: 991px) {
    gap: 8px;
  }
`;

const HeroTitle = styled.h1`
  font-size: 44px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  line-height: 52px;
  @media (max-width: 991px) {
    font-size: 24px;
    line-height: 32px;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 20px;
  font-weight: 500;
  color: #ffffff;
  margin: 0;
  max-width: 578px;
  line-height: 28px;
  @media (max-width: 991px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

const JoinButtonOrange = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f38a3e;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  width: fit-content;
  transition: background 0.2s;

  &:hover {
    background: #e07830;
  }
`;

const JoinButtonGreen = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #43a047;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  width: fit-content;
  transition: background 0.2s;
  margin: 0 auto;
  font-family: Maven Pro;
  &:hover {
    background: #388e3c;
  }
`;

// --- Rewards Section ---

const RewardsSection = styled.section`
  max-width: ${maxWidth}px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 48px;
  @media (max-width: 991px) {
    gap: 24px;
  }
`;

const SectionTitle = styled.h2`
  font-size: 30px;
  font-weight: 700;
  line-height: 40px;
  color: #111827;
  margin: 0;
  padding: 0 16px;
  text-align: center;
  @media (max-width: 991px) {
    font-size: 24px;
    line-height: 32px;
  }
`;

const SectionContainer = styled.div`
  background: ${({ bg }) => (bg ? bg : '#ffffff')};
  padding: 80px 0;
  @media (max-width: 991px) {
    padding: 40px 0px;
  }
`;

const CardsRow = styled.div`
  display: flex;
  gap: 24px;
  @media (max-width: 991px) {
    overflow: auto;
    scrollbar-width: none; /* Firefox, Safari 18.2+, Chromium 121+ */
    &::-webkit-scrollbar {
      display: none; /* Older Safari and Chromium */
    }
  }
`;

const RewardCard = styled.div`
  flex: 1;
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  &:last-child {
    margin-right: 16px;
  }
  &:first-child {
    margin-left: 16px;
  }
  @media (max-width: 991px) {
    flex-shrink: 0;
    flex-basis: 290px;
  }
`;

const RewardCardImage = styled.div`
  height: 284px;
  position: relative;
  @media (max-width: 991px) {
    height: 206px;
  }
`;

const RewardCardImageEl = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0px;
  object-fit: cover;
`;

const RewardCardBody = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  @media (max-width: 991px) {
    padding: 16px;
    flex-grow: 1;
  }
`;

const RewardCardTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0;
  line-height: 26px;
  @media (max-width: 991px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

const RewardCardDesc = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #303643;
  margin: 0;
  line-height: 24px;
  @media (max-width: 991px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

// --- How To Section ---

const HowToSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 40px;
  max-width: ${maxWidth}px;
  margin: 0 auto;
  @media (max-width: 991px) {
    gap: 24px;
  }
`;

const HowToHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 0 auto;
  align-items: center;
  @media (max-width: 991px) {
    gap: 8px;
  }
`;

const ViewTermsLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 16px;
  font-weight: 500;
  color: #3c9041;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-family: Maven Pro;
  &:hover {
    text-decoration: underline;
  }
`;

const TabRow = styled.div`
  display: flex;
  @media (min-width: 992px) {
    margin-left: 16px;
  }
`;

const Tab = styled.button<{ active: boolean }>`
  padding: 8px 0 10px;
  font-size: 18px;
  font-weight: ${({ active }: { active: boolean }) => (active ? '600' : '400')};
  color: ${({ active }: { active: boolean }) => (active ? '#43a047' : '#4b5563')};
  background: none;
  border: none;
  border-bottom: ${({ active }: { active: boolean }) => (active ? '3px solid #43a047' : '1px solid #e5e7eb')};
  cursor: pointer;
  min-width: 175px;
  text-align: center;
  line-height: 24px;
  font-family: Maven Pro;
  @media (max-width: 991px) {
    flex-grow: 1;
    font-size: 16px;
  }
`;

const StepsRow = styled.div`
  display: flex;
  gap: 40px;
  @media (max-width: 991px) {
    gap: 24px;
    overflow: auto;
    scrollbar-width: none; /* Firefox, Safari 18.2+, Chromium 121+ */
    &::-webkit-scrollbar {
      display: none; /* Older Safari and Chromium */
    }
  }
`;

const StepCard = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #f2f2f2;
  border-radius: 16px;
  &:last-child {
    margin-right: 16px;
  }
  &:first-child {
    margin-left: 16px;
  }
  @media (max-width: 991px) {
    flex-shrink: 0;
    flex-basis: 290px;
  }
`;

const StepCardImage = styled.div`
  height: 385px;
  position: relative;
  background: rgb(248 249 249);
  @media (max-width: 991px) {
    height: 288px;
  }
`;

const StepCardImageEl = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: -2px;
  object-fit: contain;
`;

const StepCardBody = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StepCardTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0;
  line-height: 26px;
  @media (max-width: 991px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

const StepCardDesc = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #303643;
  margin: 0;
  line-height: 24px;
`;

// --- FAQ Section ---

const FaqSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 0 16px;
  max-width: ${maxWidth}px;
  margin: 0 auto;
  align-items: center;
  @media (max-width: 991px) {
    gap: 24px;
  }
`;

const FaqInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
  width: 100%;
  @media (max-width: 991px) {
    gap: 24px;
  }
`;

const FaqList = styled.div`
  background: #ffffff;
  border-radius: 8px;
  padding: 8px 32px;
  display: flex;
  flex-direction: column;
  max-width: 765px;
  width: 100%;
  @media (max-width: 767px) {
    padding: 0px 16px;
  }
`;

const FaqItem = styled.div`
  border-bottom: 1px solid #e5e7eb;
  padding: 24px 0px;
  &:last-child {
    border-bottom: none;
  }
  @media (max-width: 767px) {
    padding: 16px 0px;
  }
`;

const FaqQuestion = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  cursor: pointer;
`;

const FaqQuestionText = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

const ChevronIcon = styled.span<{ open: boolean }>`
  display: inline-flex;
  align-items: center;
  transform: ${({ open }: { open: boolean }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s;
  flex-shrink: 0;
`;

const FaqAnswer = styled.p`
  font-size: 16px;
  color: #374151;
  margin: 12px 0 0;
  line-height: 24px;
  white-space: pre-line;
  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

// --------------- Component ---------------

const FAQ_ITEMS = [
  { question: messages.faq1Question, answer: messages.faq1Answer },
  { question: messages.faq2Question, answer: messages.faq2Answer },
  { question: messages.faq3Question, answer: messages.faq3Answer },
  { question: messages.faq4Question, answer: messages.faq4Answer },
  { question: messages.faq5Question, answer: messages.faq5Answer },
  { question: messages.faq6Question, answer: messages.faq6Answer },
];

const REFERRER_STEPS = [
  {
    title: messages.step1Title,
    desc: messages.step1Desc,
    images: {
      vi: ReferrerStep1,
      en: ReferrerStep1En,
    },
  },
  {
    title: messages.step2Title,
    desc: messages.step2Desc,
    images: {
      vi: ReferrerStep2,
      en: ReferrerStep2En,
    },
  },
  {
    title: messages.step3Title,
    desc: messages.step3Desc,
    images: {
      vi: ReferrerStep3,
      en: ReferrerStep3En,
    },
  },
];

const REFEREE_STEPS = [
  {
    title: messages.step1Title,
    desc: messages.refereeStep1Desc,
    images: {
      vi: RefereeStep1,
      en: RefereeStep1En,
    },
  },
  {
    title: messages.step2Title,
    desc: messages.refereeStep2Desc,
    images: {
      vi: RefereeStep2,
      en: RefereeStep2En,
    },
  },
  {
    title: messages.step3Title,
    desc: messages.refereeStep3Desc,
    images: {
      vi: RefereeStep3,
      en: RefereeStep3En,
    },
  },
];

type Props = RouteProps & RouteComponentProps;

const LandingPageReferral: React.FC<Props> = ({ history }) => {
  const [activeTab, setActiveTab] = useState<'referrer' | 'referee'>('referrer');
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const lang = localStorage.getItem('lang') || 'vi';
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const goToReferral = () => {
    const token = localStorage.getItem('token');
    if (token) {
      window.open('/refer-friends', '_blank');
      return;
    }
    sessionStorage.setItem('fromReferral', 'true');
    history.push('/signin');
  };
  const stepsData = activeTab === 'referrer' ? REFERRER_STEPS : REFEREE_STEPS;
  return (
    <PageWrapper>
      {/* Hero Section */}
      <HeroSection>
        <HeroInner>
          <HeroContent>
            <HeroTextGroup>
              <HeroTitle>
                <FormattedMessage {...messages.heroTitle} />
              </HeroTitle>
              <HeroSubtitle>
                <FormattedMessage {...messages.heroSubtitle} />
              </HeroSubtitle>
            </HeroTextGroup>
            <JoinButtonOrange onClick={goToReferral}>
              <FormattedMessage {...messages.joinNow} />
              <SVGIcon src={ArrowRight} />
            </JoinButtonOrange>
          </HeroContent>
          <HeroImagePlaceholder />
        </HeroInner>
      </HeroSection>

      {/* What You'll Get Section */}
      <SectionContainer bg={'#f7f7f8'}>
        <RewardsSection>
          <SectionTitle>
            <FormattedMessage {...messages.rewardsSectionTitle} />
          </SectionTitle>
          <CardsRow>
            <RewardCard>
              <RewardCardImage>
                <RewardCardImageEl src={Benefit1} />
              </RewardCardImage>
              <RewardCardBody>
                <RewardCardTitle>
                  <FormattedMessage {...messages.referrerTitle} />
                </RewardCardTitle>
                <RewardCardDesc>
                  <FormattedMessage {...messages.referrerDesc} />
                </RewardCardDesc>
              </RewardCardBody>
            </RewardCard>

            <RewardCard>
              <RewardCardImage>
                <RewardCardImageEl src={Benefit2} />
              </RewardCardImage>
              <RewardCardBody>
                <RewardCardTitle>
                  <FormattedMessage {...messages.refereeTitle} />
                </RewardCardTitle>
                <RewardCardDesc>
                  <FormattedMessage {...messages.refereeDesc} />
                </RewardCardDesc>
              </RewardCardBody>
            </RewardCard>

            <RewardCard>
              <RewardCardImage>
                <RewardCardImageEl src={Benefit3} />
              </RewardCardImage>
              <RewardCardBody>
                <RewardCardTitle>
                  <FormattedMessage {...messages.extraGiftTitle} />
                </RewardCardTitle>
                <RewardCardDesc>
                  <FormattedMessage {...messages.extraGiftDesc} />
                </RewardCardDesc>
              </RewardCardBody>
            </RewardCard>
          </CardsRow>
        </RewardsSection>
      </SectionContainer>

      {/* How To Section */}
      <SectionContainer>
        <HowToSection>
          <HowToHeader>
            <SectionTitle>
              <FormattedMessage {...messages.howToTitle} />
            </SectionTitle>
            <ViewTermsLink
              onClick={() =>
                window.open(
                  'https://image-handler-prod.s3.ap-southeast-1.amazonaws.com/supplier/654/FILE/Copy+of+Term+%26+Condition+Referral+3.0.pdf',
                  '_blank',
                )
              }
            >
              <FormattedMessage {...messages.viewTerms} />
              <SVGIcon src={ArrowRight} color="#3c9041" />
            </ViewTermsLink>
          </HowToHeader>

          <TabRow>
            <Tab active={activeTab === 'referrer'} onClick={() => setActiveTab('referrer')}>
              <FormattedMessage {...messages.tabReferrer} />
            </Tab>
            <Tab active={activeTab === 'referee'} onClick={() => setActiveTab('referee')}>
              <FormattedMessage {...messages.tabReferee} />
            </Tab>
          </TabRow>

          <StepsRow>
            {stepsData.map((step, index) => (
              <StepCard key={index}>
                <StepCardImage>
                  <StepCardImageEl src={step?.images[lang]} />
                </StepCardImage>
                <StepCardBody>
                  <StepCardTitle>
                    <FormattedMessage {...step.title} />
                  </StepCardTitle>
                  <StepCardDesc>
                    <FormattedMessage {...step.desc} />
                  </StepCardDesc>
                </StepCardBody>
              </StepCard>
            ))}
          </StepsRow>

          <JoinButtonGreen onClick={goToReferral}>
            <FormattedMessage {...messages.joinNow} />
            <SVGIcon src={ArrowRight} />
          </JoinButtonGreen>
        </HowToSection>
      </SectionContainer>

      {/* FAQ Section */}
      <SectionContainer bg={'#f7f7f8'}>
        <FaqSection>
          <FaqInner>
            <SectionTitle>
              <FormattedMessage {...messages.faqTitle} />
            </SectionTitle>
            <FaqList>
              {FAQ_ITEMS.map(({ question, answer }, index) => (
                <FaqItem key={index} onClick={() => toggleFaq(index)}>
                  <FaqQuestion>
                    <FaqQuestionText>
                      <FormattedMessage {...question} />
                    </FaqQuestionText>
                    <ChevronIcon open={openFaq === index}>
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                          d="M4 6L8 10L12 6"
                          stroke="#4b5563"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </ChevronIcon>
                  </FaqQuestion>
                  {openFaq === index && (
                    <FaqAnswer dangerouslySetInnerHTML={{ __html: translations(answer) }}>
                      {/* <FormattedMessage {...answer} /> */}
                    </FaqAnswer>
                  )}
                </FaqItem>
              ))}
            </FaqList>
          </FaqInner>

          <JoinButtonGreen onClick={goToReferral}>
            <FormattedMessage {...messages.joinNow} />
            <SVGIcon src={ArrowRight} />
          </JoinButtonGreen>
        </FaqSection>
      </SectionContainer>
    </PageWrapper>
  );
};

export default withRouter(LandingPageReferral);
